import * as React from 'react';

import {
    getLoadedComponentsCacheKey,
    loadCodeBlockSyntaxesAsync,
    loadCodeBlockSyntaxesSuspend,
} from './syntaxes';

/**
 * Load Prism syntaxes.
 */
export function useLoadSyntaxes(
    syntaxes: string[],
    options?: {
        /**
         * Whether to suspend rendering while loading syntaxes.
         * @default false
         */
        suspend: boolean;
    }
): string {
    const suspend = options?.suspend ?? false;
    const [loadedSyntaxes, setLoadedSyntaxes] = React.useState(getLoadedComponentsCacheKey);

    if (suspend) {
        loadCodeBlockSyntaxesSuspend(syntaxes);
    }

    React.useEffect(() => {
        if (!suspend && syntaxes.length > 0) {
            loadCodeBlockSyntaxesAsync(syntaxes).then(() => {
                setLoadedSyntaxes(getLoadedComponentsCacheKey());
            });
        }
    }, [suspend, syntaxes.join('-')]);

    return loadedSyntaxes;
}
